export const BULK_REMOVE_SUPER_BATCHES_MODAL_STAGES = {
  notOpen: 'notOpen',
  info: 'info',
  select: 'select',
  confirm: 'confirm',
};
